/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import { StyleSheet } from 'aphrodite';
import { colors, LoadingSpinner, mixins } from '@blend/consumer-components';

import { useHistory } from 'react-router';
import { useRoom } from '../../../hooks/useRoom';
import { participantAPI } from '../../../api/participant';
import { ActionButton } from '@components/ActionButton/ActionButton';
import { onboardingPerformanceTracker } from '@utils/onboardingPerformanceTracker';

export namespace WaitingRoom {
  export interface Props {
    task: any;
  }
}
const styles = StyleSheet.create({
  // need to add additional 12px padding on the left to center the spinner, because spinner is not centered in
  // spinner wrapper.
  spinnerButton: {
    ...mixins.padding(15, 32, 15, 32 + 12),
    cursor: 'not-allowed',
  },
});

export const WaitingRoom: React.SFC<WaitingRoom.Props> = ({ task }) => {
  const { roomId } = useRoom();
  const history = useHistory();
  const maybeNavigate = async (): Promise<void> => {
    const session = await participantAPI.sessions.fetchSession();
    if (session.videoAccessToken) {
      onboardingPerformanceTracker.completeStep(task.id, task.templateId, true);
      history.push(`/rooms/${roomId}/signing`);
    }
  };

  useEffect(() => {
    maybeNavigate();
    const interval = setInterval(maybeNavigate, 5000);
    return () => clearInterval(interval);
  }, [roomId]);

  return (
    <ActionButton
      data-dd-privacy="allow"
      color={colors.catalyst}
      sizing="full"
      customStyle={styles.spinnerButton}
      data-it="Spinner-Button"
    >
      <LoadingSpinner color="white" size="sm" />
    </ActionButton>
  );
};
